import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { NAVIGATION } from '../../../containers/App/constants';
import { SearchIcon } from '../../../images/icons/search';
import { ReactComponent as IconTicket } from '../../../images/icons/ticket.svg';
import { colors } from '../../../styles/constants';
import { stripLocale } from '../../../utils/i18nUrls';
import { Icon18 } from '../../Icon';
import messages from '../messages';

const LinkList = styled.div`
  ${tw`flex justify-around`}
`;

const Link = styled(NavLink)`
  ${tw`flex flex-col items-center no-underline w-full text-text`}
  gap:var(--size-small);

  font-size: 14px;
  * {
    font-weight: bold !important;
  }

  svg {
    ${Icon18}
  }

  path {
    stroke: ${colors.primary400};
  }

  &.active > *,
  &.active path {
    stroke: ${colors.secondary400};
    color: ${colors.secondary400};
  }
`;

const LinkContainer = styled.div`
  ${tw`w-full`}
`;

const LinkTitle = styled.span`
  ${tw`font-normal`}
`;

type NavigationProps = {
  pathname: string;
};

export const Navigation = ({ pathname: rawPathname }: NavigationProps) => {
  const pathname = stripLocale(rawPathname);

  return (
    <LinkList>
      <LinkContainer>
        <Link
          exact
          isActive={() =>
            pathname === NAVIGATION.HOME ||
            [NAVIGATION.SEARCH].some((url) => pathname.startsWith(url))
          }
          to={NAVIGATION.HOME}
        >
          <SearchIcon color={colors['primary-400']} />
          <FormattedMessage {...messages.search}>
            {(msg) => <LinkTitle>{msg}</LinkTitle>}
          </FormattedMessage>
        </Link>
      </LinkContainer>

      <LinkContainer>
        <Link
          exact
          isActive={() =>
            [NAVIGATION.LOGIN, NAVIGATION.ORDERS].includes(pathname)
          }
          to={NAVIGATION.ORDERS}
        >
          <IconTicket />
          <FormattedMessage {...messages.myOrders}>
            {(msg) => <LinkTitle>{msg}</LinkTitle>}
          </FormattedMessage>
        </Link>
      </LinkContainer>
    </LinkList>
  );
};
